"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var ListItemIndexesForRenderingHandler = /** @class */ (function () {
    function ListItemIndexesForRenderingHandler() {
    }
    ListItemIndexesForRenderingHandler.getAmountOfViewableListItemInListPart = function (listPartHeight, listItemHeight) {
        return Math.round(listPartHeight / listItemHeight) ||
            this.reservingAmountOfItemsForRendering;
    };
    ListItemIndexesForRenderingHandler.getListItemMovementToTop = function (listPartTop, firstListItemTop) {
        return listPartTop - firstListItemTop + this.listItemPadding;
    };
    ListItemIndexesForRenderingHandler.getListItemIndexByScroll = function (listItemMovementToTop, listItemHeight) {
        return Math.floor(listItemMovementToTop / listItemHeight);
    };
    ListItemIndexesForRenderingHandler.getSpecs = function (firstListItem, listPart) {
        var firstListItemTop = firstListItem.top;
        var listItemHeight = firstListItem.height;
        var listPartTop = listPart.top;
        var listPartHeight = listPart.height;
        var amountOfViewableListItemInListPart = this.getAmountOfViewableListItemInListPart(listPartHeight, listItemHeight);
        var listItemMovementToTop = this.getListItemMovementToTop(listPartTop, firstListItemTop);
        var listItemIndexByScroll = this.getListItemIndexByScroll(listItemMovementToTop, listItemHeight);
        return ({
            amountOfViewableListItemInListPart: amountOfViewableListItemInListPart,
            listItemMovementToTop: listItemMovementToTop,
            listItemIndexByScroll: listItemIndexByScroll,
        });
    };
    ListItemIndexesForRenderingHandler.getStartIndex = function (indexNow, amountOfViewableListItemInListPart) {
        var rawStartIndex = indexNow - amountOfViewableListItemInListPart - this.reservingAmountOfItemsForRendering;
        var startIndex = rawStartIndex < 0 ? 0 : rawStartIndex;
        return startIndex;
    };
    ListItemIndexesForRenderingHandler.getEndIndex = function (params) {
        var indexNow = params.indexNow, amountOfViewableListItemInListPart = params.amountOfViewableListItemInListPart, listLastIndex = params.listLastIndex;
        var rawEndIndex = indexNow + amountOfViewableListItemInListPart * 2 + this.reservingAmountOfItemsForRendering;
        var listItemForRenderingEndIndex = rawEndIndex > listLastIndex ? listLastIndex : rawEndIndex;
        return listItemForRenderingEndIndex;
    };
    ListItemIndexesForRenderingHandler.getStartToEndIndexes = function (params) {
        var indexNow = params.indexNow, amountOfViewableListItemInListPart = params.amountOfViewableListItemInListPart;
        var listItemForRenderingStartIndex = this.getStartIndex(indexNow, amountOfViewableListItemInListPart);
        var listItemForRenderingEndIndex = this.getEndIndex(params);
        var listItemStartEndIndexesForRendering = [
            listItemForRenderingStartIndex,
            listItemForRenderingEndIndex
        ];
        return listItemStartEndIndexesForRendering;
    };
    ListItemIndexesForRenderingHandler.getStartToEndIndexesFromDOM = function (_a) {
        var indexNow = _a.indexNow, listLastIndex = _a.listLastIndex, firstListItem = _a.firstListItem, listPart = _a.listPart;
        var specs = this.getSpecs(firstListItem, listPart);
        var startToEndIndexes = this.getStartToEndIndexes(__assign(__assign({}, specs), { indexNow: indexNow,
            listLastIndex: listLastIndex }));
        return startToEndIndexes;
    };
    ListItemIndexesForRenderingHandler.checkIndexIsInInStartToEndIndexes = function (index, startToEndIndexes) {
        if (index >= startToEndIndexes[0] && index <= startToEndIndexes[1]) {
            return true;
        }
        return false;
    };
    ListItemIndexesForRenderingHandler.getSingleSelectOrEmptyListItemByCheckShouldRender = function (index, startToEndIndexesForRendering) {
        var _this = this;
        return function (singleSelect, emptyListItem) {
            var shouldRender = _this.checkIndexIsInInStartToEndIndexes(index, startToEndIndexesForRendering);
            if (shouldRender) {
                return singleSelect;
            }
            return emptyListItem;
        };
    };
    ListItemIndexesForRenderingHandler.listItemPadding = 8;
    ListItemIndexesForRenderingHandler.reservingAmountOfItemsForRendering = 5;
    return ListItemIndexesForRenderingHandler;
}());
exports.default = ListItemIndexesForRenderingHandler;
